import styled, { css } from 'styled-components';

import { colors, radius } from '../../styles/tokens';

interface ContainerProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const ContainerInput = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: stretch;
  padding: 0 12px;
  transition: border-color 0.2s;

  width: 100%;

  height: 44px;
  border-radius: ${radius.full};
  flex: 1;

  background-color: ${colors.surfaceContainer};
  border: 1px solid ${colors.outlineVariant};

  gap: 8px;

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.primary};
    `}
`;

export const Input = styled.input`
  padding: 0;
  border: none;
  background-color: transparent;

  width: 100%;

  color: ${colors.onSurface};

  font-size: 16px;
  font-weight: 400;

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }
`;
